const parseTokenData = (token) => JSON.parse(atob(token.split('.')[1]))

export function parseUserFromToken(token) {
  if (!token) {
    return null
  }

  const payload = parseTokenData(token)
  if (!payload) {
    return null
  }

  return {
    id: payload.id,
    email: payload.email,
  }
}
